module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Db-Ed-Ga.64b2c0c5.png";